import {
  FAILURE_CREATE_SURVEY,
  FAILURE_DELETE_SURVEY,
  FAILURE_FETCH_SURVEYS,
  FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  FAILURE_UPDATE_SURVEY,
  REQUEST_CREATE_SURVEY,
  REQUEST_DELETE_SURVEY,
  REQUEST_FETCH_SURVEYS,
  REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  REQUEST_UPDATE_SURVEY,
  RESET_SURVEY_ID,
  RESET_SURVEY_STATE,
  SET_SURVEY_ID,
  SUCCESS_CREATE_SURVEY,
  SUCCESS_DELETE_SURVEY,
  SUCCESS_FETCH_SURVEYS,
  SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL,
  SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY,
  SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES,
  SUCCESS_UPDATE_SURVEY,
} from 'actions/actionTypes';
import { QUESTION_CATEGORY_TYPES } from 'constants/surveys';
import {
  BackendSurveyActionTypes,
  BackendSurveyState,
  SurveyTypes,
} from 'types/backend/engagementSurvey/result';
import { formatDate } from 'utils/date/dateFormat';

export const initialState: BackendSurveyState = {
  currentSurveyId: null,
  isInitializedSurveys: false,
  surveys: [],
  visibleResultSurveys: [],
  isLoadingSurveys: false,
  isLoadingResultRatioSummary: false,
  isLoadingResultRatioDistribution: false,
  isLoadingResultRatioEngagements: false,
  isLoadingResultRatioTimeSeries: false,
  isLoadingResultRatioDepartments: false,
  resultRatioSummary: null,
  resultRatioDistribution: null,
  resultRatioEngagements: null,
  resultRatioTimeSeries: null,
  resultRatioDepartments: null,
  ancestorDepartments: [],
  selfDepartment: null,
  isLoadingResultCategorySummary: false,
  resultCategorySummary: {
    id: '',
    uuid: '',
    categories: QUESTION_CATEGORY_TYPES.map((categoryType: string) => {
      return {
        categoryType,
        label: null,
        score: null,
        deviation: null,
        diff: null,
      };
    }),
  },
  isLoadingResultCategoryDetails: {
    company: false,
    business: false,
    organization: false,
    boss: false,
    associate: false,
    treatment: false,
    recognition: false,
    opportunity: false,
  },
  resultCategoryDetails: {
    company: {
      categoryType: 'company',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    business: {
      categoryType: 'business',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    organization: {
      categoryType: 'organization',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    boss: {
      categoryType: 'boss',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    associate: {
      categoryType: 'associate',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    treatment: {
      categoryType: 'treatment',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    recognition: {
      categoryType: 'recognition',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
    opportunity: {
      categoryType: 'opportunity',
      label: '',
      score: null,
      deviation: null,
      diff: null,
      children: [],
    },
  },
};

export const backendEngagementSurveyResultsReducer = (
  state = initialState,
  action: BackendSurveyActionTypes,
): BackendSurveyState => {
  switch (action.type) {
    case RESET_SURVEY_STATE: {
      return initialState;
    }
    case REQUEST_FETCH_SURVEYS: {
      return {
        ...state,
        isLoadingSurveys: true,
      };
    }
    case SUCCESS_FETCH_SURVEYS: {
      const { payload } = action;

      // レポート、比較用のタブに表示する際は時刻表示無しに整形
      // 診断一覧、詳細は各コンポーネントで時刻込みに整形
      const visibleSurveys = payload.filter((survey) => {
        return survey.phase !== 'before';
      });

      const visibleResultSurveys = visibleSurveys.map((survey) => {
        return {
          ...survey,
          startAt: formatDate(survey.startAt),
          endAt: formatDate(survey.endAt),
        };
      });

      return {
        ...state,
        isInitializedSurveys: true,
        isLoadingSurveys: false,
        surveys: payload,
        visibleResultSurveys,
      };
    }
    case FAILURE_FETCH_SURVEYS: {
      return {
        ...state,
        isInitializedSurveys: true,
        isLoadingSurveys: false,
      };
    }
    case REQUEST_CREATE_SURVEY: {
      return {
        ...state,
      };
    }
    case SUCCESS_CREATE_SURVEY: {
      const { payload } = action;

      return {
        ...state,
        surveys: [payload, ...state.surveys],
      };
    }
    case FAILURE_CREATE_SURVEY: {
      return {
        ...state,
      };
    }
    case REQUEST_UPDATE_SURVEY: {
      return {
        ...state,
      };
    }
    case SUCCESS_UPDATE_SURVEY: {
      const { payload } = action;

      const updatedSurveys = state.surveys.map((survey: SurveyTypes) => {
        if (survey.id === payload.id) return payload;
        return survey;
      });

      return {
        ...state,
        surveys: updatedSurveys,
      };
    }
    case FAILURE_UPDATE_SURVEY: {
      return {
        ...state,
      };
    }
    case REQUEST_DELETE_SURVEY: {
      return {
        ...state,
      };
    }
    case SUCCESS_DELETE_SURVEY: {
      const { id } = action;

      const inactivedSurvey = state.surveys.find((survey: SurveyTypes) => {
        return survey.id === id;
      });

      if (!inactivedSurvey) return state;

      // inactiveされた診断より高いindex番号を持つ診断のindex番号を繰り下げ
      const formattedSurveys = state.surveys.map((survey: SurveyTypes) => {
        if (survey.index < inactivedSurvey.index) {
          return { ...survey };
        }
        return { ...survey, index: survey.index - 1 };
      });

      const surveys = formattedSurveys.filter((survey: SurveyTypes) => {
        return survey.id !== id;
      });

      return {
        ...state,
        surveys,
      };
    }
    case FAILURE_DELETE_SURVEY: {
      return {
        ...state,
      };
    }
    case SET_SURVEY_ID: {
      const { id } = action;
      return {
        ...state,
        currentSurveyId: id,
      };
    }
    case RESET_SURVEY_ID: {
      return {
        ...state,
        currentSurveyId: null,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_RATIO_SUMMARY: {
      return {
        ...state,
        isLoadingResultRatioSummary: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_RATIO_SUMMARY: {
      const { payload } = action;

      const formatted = { ...payload, startAt: formatDate(payload.startAt) };

      return {
        ...state,
        isLoadingResultRatioSummary: false,
        resultRatioSummary: formatted,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_RATIO_SUMMARY: {
      return {
        ...state,
        isLoadingResultRatioSummary: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION: {
      return {
        ...state,
        isLoadingResultRatioDistribution: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION: {
      const { payload } = action;

      return {
        ...state,
        isLoadingResultRatioDistribution: false,
        resultRatioDistribution: payload,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_RATIO_DISTRIBUTION: {
      return {
        ...state,
        isLoadingResultRatioDistribution: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS: {
      return {
        ...state,
        isLoadingResultRatioEngagements: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS: {
      const { payload } = action;
      const formatted = { ...payload, startAt: formatDate(payload.startAt) };

      return {
        ...state,
        isLoadingResultRatioEngagements: false,
        resultRatioEngagements: formatted,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_RATIO_ENGAGEMENTS: {
      return {
        ...state,
        isLoadingResultRatioEngagements: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES: {
      return {
        ...state,
        isLoadingResultRatioTimeSeries: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES: {
      const { payload } = action;

      const formatted = payload.map((survey) => {
        return { ...survey, startAt: formatDate(survey.startAt) };
      });

      return {
        ...state,
        isLoadingResultRatioTimeSeries: false,
        resultRatioTimeSeries: formatted,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_RATIO_TIME_SERIES: {
      return {
        ...state,
        isLoadingResultRatioTimeSeries: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS: {
      const { parentId } = action;
      // リロードと診断切り替え時にパンくずをリセット
      if (parentId === null) {
        return {
          ...state,
          isLoadingResultRatioDepartments: true,
          ancestorDepartments: [],
          selfDepartment: null,
        };
      }
      return {
        ...state,
        isLoadingResultRatioDepartments: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS: {
      const { payload } = action;
      const formatted = { ...payload, startAt: formatDate(payload.startAt) };
      // chat.jsクリック時のリクエスト制御(子部署有無判定)ができない。のでレスポンス有無で処理を分岐させる。
      if (payload.segment.length) {
        return {
          ...state,
          isLoadingResultRatioDepartments: false,
          resultRatioDepartments: formatted,
          ancestorDepartments: payload.segment[0].ancestors.slice(
            0,
            payload.segment[0].ancestors.length - 1,
          ), // chart.jsでクリックされた部署の祖先部署
          selfDepartment: payload.segment[0].ancestors.slice(-1)[0], // chart.jsでクリックされた部署自身
        };
      }
      return {
        ...state,
        isLoadingResultRatioDepartments: false,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_RATIO_DEPARTMENTS: {
      return {
        ...state,
        isLoadingResultRatioDepartments: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY: {
      return {
        ...state,
        isLoadingResultCategorySummary: true,
        isLoadingResultCategoryDetails: {
          associate: true,
          boss: true,
          business: true,
          company: true,
          opportunity: true,
          organization: true,
          recognition: true,
          treatment: true,
        },
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY: {
      const { payload } = action;

      return {
        ...state,
        isLoadingResultCategorySummary: false,
        resultCategorySummary: payload,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_CATEGORY_SUMMARY: {
      return {
        ...state,
        isLoadingResultCategorySummary: false,
      };
    }
    case REQUEST_FETCH_SURVEY_RESULT_CATEGORY_DETAIL: {
      return {
        ...state,
      };
    }
    case SUCCESS_FETCH_SURVEY_RESULT_CATEGORY_DETAIL: {
      const { categoryType, payload } = action;

      const newIsLoadingResultCategoryDetails = {
        ...state.isLoadingResultCategoryDetails,
      };
      newIsLoadingResultCategoryDetails[categoryType] = false;

      const newResultCategoryDetails = { ...state.resultCategoryDetails };
      newResultCategoryDetails[categoryType] = payload;

      return {
        ...state,
        isLoadingResultCategoryDetails: newIsLoadingResultCategoryDetails,
        resultCategoryDetails: newResultCategoryDetails,
      };
    }
    case FAILURE_FETCH_SURVEY_RESULT_CATEGORY_DETAIL: {
      const { categoryType } = action;

      const newIsLoadingResultCategoryDetails = {
        ...state.isLoadingResultCategoryDetails,
      };
      newIsLoadingResultCategoryDetails[categoryType] = false;

      return {
        ...state,
        isLoadingResultCategoryDetails: newIsLoadingResultCategoryDetails,
      };
    }
    default: {
      return state;
    }
  }
};

export default backendEngagementSurveyResultsReducer;
